import RequestStatus from "../model/RequestStatus";
import {ProgramFees, ProgramParam} from "src/model/ProgramFees";
import {GetProgramFeesQueryComplete} from "src/actions/ProgramFeesQueryAction";
import QueryProductInfo from "src/model/QueryProduct";

export const NEW_PROGRAM_FEES_QUERY_START = 'NEW_PROGRAM_FEES_QUERY_START';
export const ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START = 'ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START';
export const UPDATE_NEW_PROGRAM_FEES_QUERY_START = 'UPDATE_NEW_PROGRAM_FEES_QUERY_START';
export const NEW_PROGRAM_FEES_QUERY_SUCCESS = 'NEW_PROGRAM_FEES_QUERY_SUCCESS';
export const NEW_PROGRAM_FEES_QUERY_FAILED = 'NEW_PROGRAM_FEES_QUERY_FAILED';

export interface NewProgramFeesQueryStartAction {
    readonly type: string,
    readonly requestStatus: RequestStatus,
    readonly countryCode: string,
    readonly queryProduct: QueryProductInfo;
    readonly programIdList: Array<string>;
    readonly programParamMap?: Record<string, ProgramParam>;

}

export const setNewProgramFeesQueryStart = (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>): NewProgramFeesQueryStartAction => ({
    type: NEW_PROGRAM_FEES_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    queryProduct: queryProduct,
    programIdList: programIdList
});

export const setAdditionalNewProgramFeesQueryStart = (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>, programParamMap?: Record<string, ProgramParam>): NewProgramFeesQueryStartAction => ({
    type: ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    queryProduct: queryProduct,
    programIdList: programIdList,
    programParamMap: programParamMap
});

export const setUpdateNewProgramFeesQueryStart = (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>, programParamMap?: Record<string, ProgramParam>): NewProgramFeesQueryStartAction => ({
    type: UPDATE_NEW_PROGRAM_FEES_QUERY_START,
    requestStatus: RequestStatus.UPDATING,
    countryCode: countryCode,
    queryProduct: queryProduct,
    programIdList: programIdList,
    programParamMap: programParamMap
});

export const getNewProgramFeesQuerySuccessAction = (programIdList: Array<string>, programFees: ProgramFees): GetProgramFeesQueryComplete => ({
    type: NEW_PROGRAM_FEES_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    programIdList: programIdList,
    programFees: programFees
});

export const getNewProgramFeesQueryFailedAction = (programIdList: Array<string>): GetProgramFeesQueryComplete => ({
    type: NEW_PROGRAM_FEES_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    programIdList: programIdList,
    programFees: null
});